<dx-popup
  [(width)]="width"
  [(height)]="height"
  [showTitle]="true"
  class="fuel-realtime-popup"
  [title]="name + ' - Consommation Carburant Temps Réel'"
  [dragEnabled]="true"
  [resizeEnabled]="true"
  [shading]="false"
  [closeOnOutsideClick]="false"
  [visible]="visible"
  (onShowing)="onShowing($event)"
  (onHidden)="onHidden($event)">
  <app-fuel-realtime-consumption
    [start]="start"
    [width]="width"
    [height]="height"
    [tracker]="tracker"></app-fuel-realtime-consumption>
</dx-popup>

